"use strict"

import React, { useRef, useState } from "react"
import { FormattedMessage } from "react-intl"
import { Modal, Button } from "react-bootstrap"

import CreateDataExportForm from "./forms/CreateDataExportForm"
import { PageTitle } from "../../config/AppSettingsConfigProvider"
import DataExportTable from "./DataExportTable"

export default function DataTransferScreen({ intl }) {
  const ref_table = useRef()
  const [modalVisible, setModalVisible] = useState(false)

  const closeModal = () => {
    setModalVisible(false)
  }

  const refreshTable = () => {
    ref_table.current.reloadTable()
  }

  // ----- Form: Create events -----
  const onSuccess_create = (_) => {
    alert(intl.formatMessage({ id: "datatransfer.created.message" }))
    closeModal()
    refreshTable()
  }

  const onError_create = (error) => {
    alert(
      intl.formatMessage(
        { id: "datatransfer.unable.to.create.message" },
        { err_message: JSON.stringify(error) },
      ),
    )
  }
  // ----- /Form: Create events -----

  const create_request_title = (
    <>
      <i className={"fa fa-plus"} />
      &nbsp;
      <FormattedMessage
        id={"datatransfer.create.request.button"}
        description={"Data Transfer Create Request Title"}
      />
    </>
  )
  return (
    <div className={"content-block full-height-min"}>
      <PageTitle
        glyph={"arrow-circle-o-down"}
        id={"navigation.dataTransferOption"}
        description={"Data Transfer"}
      />
      <hr />

      <div className={"row"} style={{ marginBottom: "15px" }}>
        <div className={"col-12"} align={"right"}>
          <Button variant={"outline-primary"} onClick={() => refreshTable()}>
            <i className={"fa fa-refresh"} />
            &nbsp;
            <FormattedMessage id={"general.refresh"} description={"Data Transfer Refresh Data Button"} />
          </Button>
          &nbsp;&nbsp;
          <Button variant={"outline-primary"} onClick={() => setModalVisible(true)}>
            {create_request_title}
          </Button>
        </div>
      </div>

      <DataExportTable ref={ref_table} intl={intl} />

      {/* Data Export Modal */}
      {modalVisible && (
        <Modal show={modalVisible} onHide={closeModal} backdrop={"static"} keyboard={false}>
          <Modal.Header closeButton>
            <Modal.Title>{create_request_title}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <CreateDataExportForm
              intl={intl}
              style={{ minWidth: "600px" }}
              onSuccess={onSuccess_create}
              onError={onError_create}
              onCancel={() => closeModal()}
            />
          </Modal.Body>
        </Modal>
      )}
      {/* Data Export Modal */}
    </div>
  )
}
